import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { AUTH_ROUTE, REGISTRATION_ROUTE } from '../../utils/consts';
import { createEmailStatus, createPassword, createPasswordStatus, createPhoneStatus } from '../../redux/actions/userActions';
import SelectAuth from '../../components/SelectAuth';
import AuthWrapper from '../../containers/AuthWrapper';
import useCheck from '../../hooks/authorization.hook';
import StepFirst from './containers/StepFirst';
import StepSecond from './containers/StepSecond';

const Recovery = ({ phone, email, password }) => {

    const [isEnd, setIsEnd] = useState(false);
    const [nextStep, setNextStep] = useState(false);
    const [activePhone, setActive] = useState(true);
    const [btnDisabled, setBtnDisabled] = useState(true);
    const { phoneCheck, emailCheck, doLogin, doRecovery } = useCheck();
    const dispatch = useDispatch();

    useEffect(async () => {
        dispatch(createPhoneStatus(await phoneCheck(phone, 'recovery')));
    }, [phone.value]);


    useEffect(async () => {
        dispatch(createEmailStatus(await emailCheck(email.value, phone, 'recovery')));
    }, [email.value]);

    useEffect(() => {
        phone.validation || email.validation ? setBtnDisabled(false) : setBtnDisabled(true);
    }, [phone.validation, email.validation]);

    useEffect(() => {
        if (isEnd) {
            login();
            setBtnDisabled(false);
        }
    }, [password.value]);

    const recovery = () => {
        doRecovery(activePhone ? phone : email, activePhone);
        setNextStep(true);
        setBtnDisabled(true);
    };

    const login = async () => {
        const result = await doLogin(activePhone ? phone : email, password, 'recovery', activePhone);
        dispatch(createPasswordStatus(result));
    };

    const getCode = (val, end) => {
        dispatch(createPassword(val.join('')));
        setIsEnd(end);
    };

    return (
        <Fragment>
            <AuthWrapper title='Восстановление пароля'>
                {nextStep ?
                    <StepSecond
                        getCode={getCode}
                        login={login}
                        btnDisabled={btnDisabled}
                        stepBack={setNextStep}
                        typeVerify={activePhone ? 'из СМС' : 'по E-mail'} />
                    :
                    <StepFirst
                        activePhone={activePhone}
                        setActive={setActive}
                        btnDisabled={btnDisabled}
                        recovery={recovery} />
                }
            </AuthWrapper>
            <SelectAuth
                titles={['Уже зарегистрированы ?', 'Регистрация']}
                routes={[AUTH_ROUTE, REGISTRATION_ROUTE]}
            />
        </Fragment>
    );
};


const mapStateToProps = state => {
    return {
        phone: {
            value: state.user.phone,
            validation: state.user.phoneStatus.validation,
            message: state.user.phoneStatus.message
        },
        email: {
            value: state.user.email,
            validation: state.user.emailStatus.validation,
            message: state.user.emailStatus.message
        },
        password: {
            value: state.user.password,
            validation: state.user.passwordStatus.validation,
            message: state.user.passwordStatus.message
        }
    };
};

export default connect(mapStateToProps, null)(Recovery);

Recovery.propTypes = {
    phone: PropTypes.object,
    email: PropTypes.object,
    password: PropTypes.object,
};